<template>
  <div class="review-dialog-wrap">
    <el-dialog v-loading="isLoading" :title="title" :visible.sync="dialogFormVisible" top="2vh" width="50vw"
      element-loading-text="加载中" @close="close" class="fixed-header-footer-dialog">
      <div class="dialog-content-wrapper">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="scrollable-form">
          <el-form-item label="所属用户">
            <div class="user-info">
              <span>{{ form.username || '-' }}</span>
              <span class="user-code">{{ form.user_code ? `(${form.user_code})` : '' }}</span>
            </div>
          </el-form-item>

          <el-form-item v-if="form.express_code" label="韩国单号">
            <el-input v-model.trim="form.express_code" />
          </el-form-item>

          <el-form-item label="订单状态">
            <el-select v-model="form.status" placeholder="请选择" style="width: 100%" disabled>
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="form.refuse_remark" label="驳回理由">
            <el-input v-model.trim="form.refuse_remark" />
          </el-form-item>

          <!-- 链接：逗号拆分，一行一个，行尾带复制按钮 -->
          <el-form-item :label="daifu ? '平台链接' : '物品链接'">
            <div v-for="(item, index) in linkList" :key="index" class="link-item">
              <el-input v-model="item.url" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" class="link-input"
                placeholder="请输入链接" disabled />
              <el-button type="text" icon="el-icon-document-copy" class="link-copy-btn" @click="copyLink(item.url)">
                复制
              </el-button>
            </div>
          </el-form-item>

          <template v-if="daifu">
            <el-form-item label="平台账号">
              <el-input v-model.trim="form.account" />
            </el-form-item>
            <el-form-item label="账号密码">
              <el-input v-model.trim="form.password" />
            </el-form-item>
          </template>

          <el-form-item label="物品名称">
            <el-input v-model.trim="form.name" disabled />
          </el-form-item>

          <el-form-item label="物品款式">
            <el-input v-model.trim="form.style" disabled />
          </el-form-item>

          <el-form-item label="物品数量">
            <el-input v-model.trim="form.num" maxlength="10" show-word-limit disabled />
          </el-form-item>



          <el-form-item v-if="form.pay_status == 1" label="物品总金额" prop="total_price">
            <el-input v-model.trim="form.total_price" maxlength="8" show-word-limit
              @input="handleInputPrice('total_price')" />
          </el-form-item>

          <el-form-item v-if="showBalance" label="使用余额">
            <el-input v-model.trim="form.user_balance" disabled />
          </el-form-item>

          <el-form-item v-if="showCashPay" label="现金支付">
            <el-input v-model.trim="form.price" disabled />
          </el-form-item>

          <el-form-item label="申请时间">
            <el-input v-model.trim="form.add_time" disabled />
          </el-form-item>

          <el-form-item v-if="form.remark" label="订单备注">
            <el-input v-model.trim="form.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" disabled />
          </el-form-item>

          <el-form-item v-if="form.order_pay_refund?.length" label="客服退款备注">
            <div v-for="(item, index) in form.order_pay_refund" :key="item.id || index" class="refund-item">
              <el-input v-model.trim="item.refund_remarks" disabled type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }" />
            </div>
          </el-form-item>

          <el-form-item v-if="srcList.length" label="物品图片">
            <el-image v-for="(item, index) in srcList" :key="`${item}-${index}`"
              style="width: 100px; height: 100px; margin-right: 10px" :src="item" :preview-src-list="srcList"
              :initial-index="index" fit="cover" />
          </el-form-item>
          <el-form-item v-if="form.pay_status == 0" label="物品总金额" prop="price">
            <el-input v-model.trim="form.price" maxlength="8" show-word-limit @input="handleInputPrice('price')" />
          </el-form-item>
          <el-form-item label="给客户提供反馈">
            <el-input v-model.trim="form.feedback" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button :disabled="isLoading" @click="close">取 消</el-button>
        <el-button type="danger" :disabled="isLoading" @click="openReject">审核驳回</el-button>
        <el-button type="primary" :loading="isLoading" @click="passAudit">审核通过</el-button>
      </div>
    </el-dialog>

    <reject ref="reject" @change="handleRejectChange" />
  </div>
</template>

<script>
import { buyDetail, buyUpdate, buyStatus } from '@/api/xgcApi'
import reject from './reject.vue'

// 抽成工厂函数，新增/重置/回显统一复用，避免字段遗漏
function createDefaultForm() {
  return {
    id: '',
    username: '',
    user_code: '',
    express_code: '',
    status: '',
    refuse_remark: '',
    link: '',
    account: '',
    password: '',
    name: '',
    style: '',
    user_balance: 0,
    num: '',
    price: '',
    total_price: '',
    pay_status: 0,
    add_time: '',
    remark: '',
    order_pay_refund: [],
    pic: '',
    feedback: '',
    type: '',
  }
}

// 逗号字符串 -> 链接数组
function splitLinks(link) {
  return String(link || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .map((url) => ({ url }))
}

export default {
  name: 'UserManagementEdit',
  components: { reject },
  data() {
    return {
      form: createDefaultForm(),
      // 链接数组：[{ url: 'xxx' }, ...]，一行一个
      linkList: [],
      title: '审核订单',
      srcList: [],
      dialogFormVisible: false,
      isLoading: false,
      daifu: false,
      rules: {
        price: [{ required: true, trigger: 'blur', message: '请输入物品金额' }],
        total_price: [{ required: true, trigger: 'blur', message: '请输入物品金额' }],
      },
      statusList: [
        { value: 0, label: '待审核' },
        { value: 1, label: '待支付' },
        { value: 2, label: '代采购' },
        { value: 8, label: '已采购' },
        { value: 3, label: '已入库' },
        { value: 5, label: '已取消' },
        { value: 6, label: '退款中' },
        { value: 7, label: '已退款' },
        { value: 9, label: '已驳回' },
      ],
    }
  },
  computed: {
    showBalance() {
      return Number(this.form.user_balance) > 0
    },
    showCashPay() {
      return Number(this.form.price) > 0 && Number(this.form.status) > 1
    },
  },
  methods: {
    async showEdit(row) {
      this.daifu = row.type === 2
      this.srcList = []
      this.linkList = []
      this.title = '审核订单'
      this.isLoading = true
      this.dialogFormVisible = true

      try {
        const { data } = await buyDetail({ id: row.id })
        // 以默认值为底合并，避免残留上一次的脏数据
        this.form = {
          ...createDefaultForm(),
          ...data,
          order_pay_refund: data.order_pay_refund || [],
        }
        // 链接拆成数组，逗号分隔，一行一个
        this.linkList = splitLinks(data.link)
        this.srcList = data.pic ? data.pic.split(',') : []


        console.log(this.srcList, '1245789')
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
        this.close()
      } finally {
        this.isLoading = false
      }
    },

    // 组装提交数据：把链接数组还原成逗号分隔字符串
    buildPayload() {
      return {
        ...this.form,
        link: this.linkList
          .map((item) => (item.url || '').trim())
          .filter(Boolean)
          .join(','),
      }
    },

    // 审核通过
    async passAudit() {
      if (this.form.price <= 0) {
        this.$message.warning('请输入物品金额')
        return
      }
      this.$baseConfirm('你确定要审核通过吗？', null, async () => {
        this.form.status = 1
        buyUpdate(this.buildPayload()).then(({ res }) => {
          this.$message({
            type: 'success',
            message: '审核通过'
          })
          this.$emit('fetch-data')
          this.close()
        })
      })
    },

    // 打开驳回弹窗
    openReject() {
      this.$refs.reject.showEdit(this.buildPayload())
    },

    // 驳回成功后刷新列表并关闭
    handleRejectChange() {
      this.$emit('fetch-data')
      this.close()
    },

    // 通用提交，status 由调用方决定
    async submit(status) {
      try {
        const valid = await this.$refs.form.validate().catch(() => false)
        if (!valid) return

        this.isLoading = true
        const { msg } = await buyUpdate({ ...this.buildPayload(), status })
        this.$baseMessage(msg || '操作成功', 'success')
        this.$emit('fetch-data')
        this.close()
      } catch (error) {
        console.error('提交失败:', error)
      } finally {
        this.isLoading = false
      }
    },

    // 兼容外部 ref 调用
    save() {
      this.submit(this.form.status)
    },

    // 复制链接
    async copyLink(text) {
      const value = String(text || '').trim()
      if (!value) {
        this.$message.warning('链接为空，无法复制')
        return
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(value)
        } else {
          // 兼容 http / 低版本浏览器
          const textarea = document.createElement('textarea')
          textarea.value = value
          textarea.style.position = 'fixed'
          textarea.style.top = '-9999px'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        this.$message.success('复制成功')
      } catch (error) {
        console.error('复制失败:', error)
        this.$message.error('复制失败，请手动复制')
      }
    },

    // 金额输入过滤：支持 price / total_price
    handleInputPrice(field) {
      const raw = this.form[field]
      if (!raw) return
      this.form[field] = String(raw)
        .replace(/[^\d.]/g, '')
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },

    close() {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.form = createDefaultForm()
        this.linkList = []
        this.srcList = []
        this.isLoading = false
        this.daifu = false
        this.$refs.form?.clearValidate?.()
      })
    },
  },
}
</script>

<style scoped>
/* 弹窗固定头部和尾部，中间滚动 */
:deep(.fixed-header-footer-dialog .el-dialog) {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

:deep(.fixed-header-footer-dialog .el-dialog__header) {
  flex-shrink: 0;
  border-bottom: 1px solid #e8e8e8;
  padding: 20px 20px 15px;
}

:deep(.fixed-header-footer-dialog .el-dialog__body) {
  flex: 1;
  /* overflow: hidden; */
  padding: 20px 20px 10px;
  height: 76vh;
  overflow-y: auto;
}

:deep(.fixed-header-footer-dialog .el-dialog__footer) {
  flex-shrink: 0;
  border-top: 1px solid #e8e8e8;
  padding: 15px 20px 20px;
}

/* 内容包裹器 - 负责滚动 */
.dialog-content-wrapper {
  height: 100%;
  overflow-y: auto;
  padding-right: 5px;
}

/* 美化滚动条 */
.dialog-content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.dialog-content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 表单样式 */
.scrollable-form {
  padding-bottom: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  height: 40px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
}

.user-code {
  color: #909399;
  font-size: 13px;
}

/* 链接列表：一行一个链接 + 复制按钮 */
.link-list {
  width: 100%;
}

.link-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.link-item+.link-item {
  margin-top: 8px;
}

.link-input {
  flex: 1;
  min-width: 0;
}

.link-copy-btn {
  flex-shrink: 0;
  padding: 0 4px;
  margin-top: 6px;
}

.link-empty {
  color: #909399;
  font-size: 13px;
  line-height: 32px;
}

/* 退款备注块间距 */
.refund-item+.refund-item {
  margin-top: 10px;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.el-form-item:last-child) {
  margin-bottom: 0;
}
</style>